export default __webpack_public_path__ + "static/media/6.459fe03f.svg";